export default __webpack_public_path__ + "static/media/feb2023-3.1dddce59.jpg";